import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { motion } from 'framer-motion'

import { ContentViewProps } from 'modules/trainings/components/content/types'
import { ContentModule } from 'modules/trainings/lib/content/Module'

const ModuleView = ({ contentItem }: ContentViewProps<ContentModule>) => {
  const [imageLoaded, setImageLoaded] = useState(false)

  return (
    <Box style={{ maxWidth: '720px', width: '100%', gap: '0.5rem' }}>
      <h2 className="text-3xl font-semibold f1-foreground">{contentItem.title}</h2>
      {contentItem.thumbnail && (
        <Box style={{
          borderRadius: '1rem',
          overflow: 'hidden',
          aspectRatio: '16 / 9',
          backgroundColor: '#f0f0f0'
        }}>
          <motion.img
            src={contentItem.thumbnail.url}
            alt={contentItem.title}
            initial={{ opacity: 0 }}
            animate={{ opacity: imageLoaded ? 1 : 0 }}
            transition={{ duration: 0.3 }}
            onLoad={() => setImageLoaded(true)}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </Box>
      )}
      <h2 className="text-base font-normal f1-foreground">{contentItem.description}</h2>
    </Box>
  )
}

export { ModuleView }
